/* eslint-disable max-len */
import React from "react";

interface SVGRProps {
  title?: string;
  titleId?: string;
}

const Trash = ({
    title = "trash a file",
    titleId = "tm-trash",
    ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) => (
    <svg
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 23"
        aria-hidden={!title}
        role={title ? "img" : ""}
        aria-label={title}
        height="1em"
        width="1em"
        fill="none"
    >
        <title id={titleId}>{title}</title>
        <path
		d="M16.0153 21.7671H3.98495L2.98242 5.41992H17.0179L16.0153 21.7671Z"
		stroke="#737478"
		strokeWidth="1.5"
		strokeLinecap="round"
		strokeLinejoin="round"
	/>
        <path
            d="M1.32324 5.41992L18.6768 5.41992"
            stroke="#737478"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M7.7041 9.95996V16.5373"
            stroke="#737478"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12.2959 9.95996V16.5373"
            stroke="#737478"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M4.7832 5.41992C4.7832 5.34669 4.7832 4.1172 4.7832 2.99023C4.7832 2.11856 5.48983 1.41211 6.36151 1.41211H13.6385C14.5102 1.41211 15.2168 2.11874 15.2168 2.99041V5.41992"
            stroke="#737478"
            strokeWidth="1.5"
        />
    </svg>
);

export default Trash;
